import { X } from 'lucide-react';
import { useEffect } from 'react';

export default function Modal({
  children,
  onClose,
  show,
  title,
}: {
  children: React.ReactNode;
  onClose: () => void;
  show: boolean;
  title?: string;
}) {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (show && event.target instanceof Element) {
        const modalContent = document.querySelector('.modal-content');
        if (modalContent && !modalContent.contains(event.target)) {
          onClose();
        }
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [show]);

  if (!show) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-[100] flex h-dvh w-full items-center justify-center bg-brand-midnight/60 p-4 pb-[max(1rem,env(safe-area-inset-bottom))] backdrop-blur-sm sm:p-6">
      <div className="modal-content relative flex max-h-[calc(100dvh-2rem)] w-full flex-col gap-4 overflow-y-auto rounded-2xl border border-white/80 bg-white p-4 shadow-2xl dark:border-white/10 dark:bg-brand-midnight sm:max-h-[80vh] sm:w-auto sm:min-w-[500px] sm:max-w-[75vw] sm:p-6">
        <div className="sticky top-0 flex flex-row items-center justify-between bg-white pb-2 dark:bg-brand-midnight">
          {title ? (
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
              {title}
            </h2>
          ) : null}
          <button
            type="button"
            onClick={onClose}
            aria-label="Close dialog"
            className="-mr-2 ml-auto p-2 text-gray-500 hover:text-gray-700 dark:text-gray-300 dark:hover:text-white"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}
